module.exports = __webpack_public_path__ + "media/fonts/formular-regular-webfont-b8039808580b3570558f685425f09c22.woff2";